(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["settl-pdp-ugc"] && !Shopify.designMode) return;
  try {
    
  /* Code QA round 1, 09/10/2026: one init per section root, guarded by a flag on the root so
     a theme-editor re-render never doubles the listeners, and re-run on shopify:section:load.
     Tiles carry dense indices (only complete blocks render), so a skipped block can no longer
     open another creator's clip. Arrow keys switch clips only when focus is not on the video,
     so the player's own seek keys still work. Closing always pauses, drops the src and calls
     load(), which stops the download; a close event that lands after a fast re-open is ignored. */
  (function () {
    function initUgc(root) {
      if (!root || root.dataset.ugcReady) return;
      var modal = root.querySelector('[data-ugc-modal]');
      var video = root.querySelector('[data-ugc-video]');
      if (!modal || !video || typeof modal.showModal !== 'function') return;
      root.dataset.ugcReady = '1';

      var quoteEl = root.querySelector('[data-ugc-quote]');
      var whoEl = root.querySelector('[data-ugc-who]');
      var linkEl = root.querySelector('[data-ugc-link]');
      var discEl = root.querySelector('[data-ugc-disclosure]');
      var prevBtn = root.querySelector('[data-ugc-prev]');
      var nextBtn = root.querySelector('[data-ugc-next]');
      var closeBtn = root.querySelector('[data-ugc-close]');

      var items = [];
      var index = 0;
      var lastTrigger = null;

      function show(i) {
        index = (i + items.length) % items.length;
        var it = items[index];

        video.pause();
        video.setAttribute('poster', it.poster);
        video.setAttribute('src', it.src);
        video.load();

        if (quoteEl) {
          quoteEl.textContent = it.quote || '';
          quoteEl.hidden = !it.quote;
        }
        if (whoEl) {
          var who = it.name || '';
          if (it.handle) who = who ? who + ' · ' + it.handle : it.handle;
          whoEl.textContent = who;
          whoEl.hidden = !who;
        }
        if (discEl) {
          discEl.textContent = it.disclosure || '';
          discEl.hidden = !it.disclosure;
        }
        if (linkEl) {
          if (it.link) {
            linkEl.href = it.link;
            linkEl.hidden = false;
          } else {
            linkEl.hidden = true;
            /* keep a real href so the hidden link stays crawlable (Lighthouse crawlable-anchors) */
            linkEl.href = 'https://www.instagram.com/besettl/';
          }
        }

        var many = items.length > 1;
        if (prevBtn) prevBtn.hidden = !many;
        if (nextBtn) nextBtn.hidden = !many;

        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }

      function teardown() {
        video.pause();
        video.removeAttribute('src');
        video.load();
      }

      function returnFocus() {
        if (lastTrigger) { lastTrigger.focus(); lastTrigger = null; }
      }

      function close() {
        video.pause();
        if (modal.open) modal.close();
        returnFocus();
      }

      root.querySelectorAll('[data-ugc-open]').forEach(function (btn) {
        var key = btn.getAttribute('data-ugc-open');
        var node = root.querySelector('[data-ugc-data="' + key + '"]');
        var data = null;
        try { data = node ? JSON.parse(node.textContent) : null; } catch (e) { data = null; }
        if (!data || !data.src) {
          var cell = btn.closest('li');
          if (cell) cell.hidden = true;
          return;
        }
        var pos = items.length;
        items.push(data);
        btn.addEventListener('click', function () {
          lastTrigger = btn;
          modal.showModal();
          show(pos);
        });
      });
      if (!items.length) return;

      if (closeBtn) closeBtn.addEventListener('click', close);
      if (prevBtn) prevBtn.addEventListener('click', function () { show(index - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { show(index + 1); });

      /* click the backdrop, not the content */
      modal.addEventListener('click', function (e) {
        if (e.target === modal) close();
      });
      /* Esc, the close button and the backdrop all end here. */
      modal.addEventListener('close', function () {
        if (modal.open) return;
        teardown();
        returnFocus();
      });
      modal.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        if (items.length < 2) return;
        var t = e.target;
        if (t === video || (t.closest && t.closest('video, a, input, select, textarea'))) return;
        e.preventDefault();
        show(index + (e.key === 'ArrowRight' ? 1 : -1));
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-settl-section="ugc-row"]').forEach(initUgc);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();

    if (!window.__settlUgcBound) {
      window.__settlUgcBound = true;
      document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
      document.addEventListener('shopify:section:unload', function (e) {
        e.target.querySelectorAll('[data-ugc-modal]').forEach(function (m) { if (m.open) m.close(); });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
